import { render } from "./FeatherLoaderSpinSvg.vue?vue&type=template&id=2cc1b8c6"
const script = {}
script.render = render

export default script